import React  from "react";
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Error404() {

    AnimationFileLoader();

  return (
    <>
    {/* 404 */}
    <div className="py-5 d-flex align-items-center vh-100">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    {/* 404 */}
                    <div className="card card-big">
                        <div className="card-body">
                            <div className="content-404">
                                <div className="content-404-left">
                                    <h2>Don't Cry</h2>
                                    <NavLink to="index.html">
                                        <img src="/img/icons/btn-home.svg" className="svg" alt=""/>
                                        Back Home
                                    </NavLink>
                                </div>
                                <div className="content-404-right">
                                    <h4>It's just NavLink 404 error...!</h4>
                                    <p>The page you are looking for is not available
                                        in the moments please try to anothers away
                                        thank you!</p>
                                </div>
                            </div>
                            <div className="img-404 d-flex justify-content-end">
                                <img src="/img/media/404.png" alt=""/>
                            </div>
                        </div>
                    </div>
                    {/* End 404 */}
                </div>
            </div>
        </div>
    </div>
    {/* End 404 */}
    </>
  );
}

export default Error404;
